var React = require('react');

function History (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":" M 12 2 C 7.03 2 3 6.03 3 11 L 0 11 L 3.89 14.89 L 3.96 15.03 L 8 11 L 5 11 C 5 7.13 8.13 4 12 4 C 15.87 4 19 7.13 19 11 C 19 14.87 15.87 18 12 18 C 10.07 18 8.32 17.21 7.06 15.94 L 5.64 17.36 C 7.27 18.99 9.51 20 12 20 C 16.97 20 21 15.97 21 11 C 21 6.03 16.97 2 12 2 Z  M 11 7 L 11 12 L 15.28 14.54 L 16 13.33 L 12.5 11.25 L 12.5 7 L 11 7 Z ","fill":"currentColor"}));
}

History.defaultProps = {"width":"24","height":"24","viewBox":"0 0 22 22"};

module.exports = History;

History.default = History;
